import updateTaskDetailUseCase from "./updateTaskDetailUseCase"

const deletePhotoUseCase = async (task, indexToRemove) => {
    const { data, detail } = task

    detail.images.splice(indexToRemove, 1)

    return updateTaskDetailUseCase(data.id, detail)
}

export default deletePhotoUseCase